import { useTranslation } from "react-i18next";
import { Button, Text } from "../UI";

// Shown instead of a blank/crashing screen when a record is missing or failed to load
const LoadFailedMessage = ({ text, onBack }) => {
  const { t } = useTranslation("common");

  return (
    <div
      role="alert"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 20,
        padding: "40px 20px",
      }}
    >
      <Text style={{ textAlign: "center", color: "#9FA2B4" }}>{text || t("load_failed")}</Text>
      {onBack && (
        <Button buttonStyle="border-linear" onClick={onBack}>
          {t("back")}
        </Button>
      )}
    </div>
  );
};

export default LoadFailedMessage;
